<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { supabase } from '@/supabase';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { notacoesPadrao, trimestres } from '@/store/dadosPadrao';

import Dropdown from 'primevue/dropdown';
import MultiSelect from 'primevue/multiselect';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Tag from 'primevue/tag';
import ContextMenu from 'primevue/contextmenu';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Textarea from 'primevue/textarea';

import { carregarDisciplinasDaArea } from '@/api/fetchParecer';
import ParecerCriarParecerParaEstudantes from '@/components/professor/parecer/ParecerCriarParecerParaEstudantes.vue';
import { useCriarParecerParaEstudantesStore } from '@/store/criarParecerParaEstudantesStore';
import ParecerExcluirPareceres from '@/components/professor/parecer/ParecerExcluirPareceres.vue';
import ParecerCopiarPareceres from '@/components/professor/parecer/ParecerCopiarPareceres.vue';
import { ordenarArrayDeObjetos } from '@/utils/ordenarArrayDeObjetos';
import CopiarParecerComponent from './CopiarParecerComponent.vue';
const storePareceres = useCriarParecerParaEstudantesStore();
const { pareceres, trimestresSelecionados, disciplinasSelecionadas, nomesEstudantes } = storeToRefs(storePareceres);



const store = useStore();

const router = useRouter();
const turma = computed(() => store.state.turma)
const dadosCarregados = ref(false)

const opcoesTrimestre = ref([
    { label: '1° tri', value: "1" },
    { label: '2° tri', value: "2" },
    { label: '3° tri', value: "3" },
])

const anoAtual = ref()
const areaDoConhecimento = ref()
const disciplinaDoProfessor = ref()
const disciplinasDaArea = ref([]);


const colunasSelecionadas = ref([])
const colunaAtribuirAd = ref('nota_11')
const estudantes = ref([])
const notas = ref([])

const tableHeight = ref('auto');
const menu = ref();
const items = ref([
    { label: 'Atribuir AD', icon: 'pi pi-bolt', command: () => atribuirAd() },
    {label: "Copiar Notações", icon: 'pi pi-copy', command: () => copiarNotacoes() }
]);

let colunaCopiar;

function copiarNotacoes() {
    let notasParaCopiar = ''
    notas.value.forEach(estudante => {
        if(estudante[colunaCopiar] == 1){
            notasParaCopiar += 'AB\n';
        } else if (estudante[colunaCopiar] == 2){
            notasParaCopiar += 'B\n';
        } else if (estudante[colunaCopiar] == 3) {
            notasParaCopiar += 'AD\n';
        } else if (estudante[colunaCopiar] == 4) {
            notasParaCopiar += 'AV\n';
        }else{
            alert(`O estudante ${estudante.nome} tem notação.`)
        }
        
    })
    notasParaCopiar.slice(notasParaCopiar.length - 1, notasParaCopiar.length)
    navigator.clipboard.writeText(notasParaCopiar)
    alert('Notas copiadas para a área de transferência!')
}

const onContextMenuClick = (event, coluna) => {
    menu.value.show(event);
    colunaAtribuirAd.value = coluna
    colunaCopiar = coluna;
};

const visible = ref(false)
const btnLoading = ref(false)
const dadosEditarParecer = ref()
const parecer = ref();

watch(pareceres, () => {
    if(pareceres.value.length > 0){
        pareceres.value.forEach(parecer => {
            notas.value.forEach(estudante => {
                if (parecer.estudante == estudante.id) {
                    estudante['parecer'] = parecer.parecer
                    estudante['id_parecer'] = parecer.id
                }
            })
        })
    }else{
        notas.value.forEach(estudante => {
            estudante['parecer'] = null
            estudante['id_parecer'] = null
        })
    }
    
},{deep: true})

function calculateHeight() {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Subtrai 140px para telas menores que 'md' (768px) e 70px para telas maiores
    const subtractionValue = viewportWidth < 768 ? 120 : 147;
    const desiredHeight = viewportHeight - subtractionValue;

    tableHeight.value = `${desiredHeight}px`;
}

onMounted(async () => {
    await carregarDados()
    calculateHeight();
    window.addEventListener('resize', calculateHeight);
    estudantes.value.forEach(estudante => {
        nomesEstudantes.value.push({id:estudante.users.id, nome: estudante.users.nome})
    })
})

async function carregarDados() {
    await obterAnoLetivoDaTurma()
    await carregarDisciplinas()
    disciplinasDaArea.value = await carregarDisciplinasDaArea(areaDoConhecimento.value)
    disciplinasSelecionadas.value = disciplinasDaArea.value
    await carregarEstudantes()
    await carregarNotas();

    dadosCarregados.value = true
}

function editarParecer(dados) {
    visible.value = true
    parecer.value = dados.parecer
    dadosEditarParecer.value = dados
}

async function atualizarParecer(){
    btnLoading.value = true
    const {data, error} = await supabase
    .from('pareceres')
    .update({ parecer: parecer.value })
    .eq('id', dadosEditarParecer.value.id_parecer)

    if(error){
        alert('Ocorreu um erro ao salvar o parecer '+ error.message)
        btnLoading.value = false
        return  
    }

    notas.value.forEach(estudante => {
        if (estudante.id == dadosEditarParecer.value.id) {
            estudante.parecer = parecer.value
        }
    })

    btnLoading.value = false
    visible.value = false
}

async function salvarParecer(){
    if('parecer' in dadosEditarParecer.value){
        atualizarParecer()
        return
    }
   
    btnLoading.value = true
    const {data, error} = await supabase
    .from('pareceres')
    .insert({ parecer: parecer.value, estudante: dadosEditarParecer.value.id, trimestre: trimestresSelecionados.value[0].value, anoLetivo: anoAtual.value, area: areaDoConhecimento.value })
    if(error){
        alert('Ocorreu um erro ao salvar o parecer '+ error.message)
        btnLoading.value = false
        return
    }
    notas.value.forEach(estudante => {
        if (estudante.id == dadosEditarParecer.value.id) {
            estudante.parecer = parecer.value
        }
    })

    btnLoading.value = false
    visible.value = false

    
}

async function atribuirAd() {
    let array = []
    notas.value.forEach(estudante => {
        if (estudante[colunaAtribuirAd.value] == null) {
            estudante[colunaAtribuirAd.value] = 3
            array.push({ notacao: 3, estudante: estudante.id, disciplina: extrairDisciplinaDeColuna(colunaAtribuirAd.value), trimestre: extrairTrimestreDeColuna(colunaAtribuirAd.value), ano_letivo: anoAtual.value })
        }
    })
    const { data, error } = await supabase
        .from('notacoes')
        .insert(array)
        .select()

    if (error) {
        alert('Ocorreu um erro ao salvar as notas. Experimento recarregar a página ' + error.message)
        return
    }
    console.log(notas.value)
}
async function carregarNotas() {

    if (disciplinasSelecionadas.value.length == 0 || trimestresSelecionados.value.length == 0) {
        notas.value = []
        return
    }

    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
        .from('notacoes')
        .select('*')
        .eq('ano_letivo', anoAtual.value)
        .in('trimestre', trimestresSelecionados.value.map(trimestre => trimestre.value))
        .in('disciplina', disciplinasSelecionadas.value.map(disciplina => disciplina.id))
        .in('estudante', estudantes.value.map(estudante => estudante.users.id))
    if (error) {
        store.dispatch('updateLoading', false)
        alert('Ocorreu um erro ao carregar as notas. Experimento recarregar a página ' + error.message)
        return
    }



    store.dispatch('updateLoading', false)

    criarNotas(data)

}

async function carregarPareceres(){
    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
        .from('pareceres')
        .select('*, users(nome)')
        .eq('anoLetivo', anoAtual.value)
        .eq('area', areaDoConhecimento.value)
        .in('trimestre', trimestresSelecionados.value.map(trimestre => trimestre.value))
        .in('estudante', estudantes.value.map(estudante => estudante.users.id))

    if (error) {
        store.dispatch('updateLoading', false)
        alert('Ocorreu um erro ao carregar os pareceres. Experimento recarregar a página ' + error.message)
        return
    }
    store.dispatch('updateLoading', false)
    console.log(data)
    return data

}

async function criarNotas(dadosSalvos) {
    
    let colunas = []

    disciplinasSelecionadas.value.forEach(disciplina => {
        trimestresSelecionados.value.forEach(trimestre => {
            colunas.push({ id: disciplina.id + trimestre.value, disciplina: disciplina, trimestre: trimestre })
        })
    })

    colunasSelecionadas.value = colunas

    let array = []
    estudantes.value.forEach(estudante => {
        let notasEstudante = {}
        colunasSelecionadas.value.forEach(coluna => {
            notasEstudante[`nota_${coluna.id}`] = null
        })
        notasEstudante['nome'] = estudante.users.nome
        notasEstudante['id'] = estudante.users.id
        notasEstudante['img'] = estudante.users.img
        array.push(notasEstudante)

    })
    array = ordenarArrayDeObjetos(array, 'nome')

    notas.value = []
    notas.value = array

    dadosSalvos.forEach(nota => {
        notas.value.forEach(estudante => {
            if (nota.estudante == estudante.id) {
                console.log('achou')
                estudante[`nota_${nota.disciplina}${nota.trimestre}`] = nota.notacao
                estudante[`id_${nota.disciplina}${nota.trimestre}`] = nota.id
            }
        })
    })

    if(trimestresSelecionados.value.length > 1) return

    pareceres.value = await carregarPareceres();

}

const obterAnoLetivoDaTurma = async () => {
    const { data, error } = await supabase
        .from('aulas')
        .select('cursos(anoLetivo)')
        .eq('id', turma.value.idDaAula)
        .single()

    if (error) {
        alert('Ocorreu um erro ao carregar os anos letivo. Experimento recarregar a página ' + error.message)
        return
    }

    anoAtual.value = data.cursos.anoLetivo


}

function onCellEditComplete(event) {
    console.log(event)


    let estudanteIndex = notas.value.findIndex(estudante => estudante.id === event.newData.id)
    notas.value[estudanteIndex][event.field] = event.newValue


    let disciplina = extrairDisciplinaDeColuna(event.field)
    let trimestre = extrairTrimestreDeColuna(event.field)
    if (event.newValue == null) return

    // atualizar ou salvar
    if (event.field.replace('nota_', 'id_') in event.newData) {
        atualizarNotacao(event.newData[event.field.replace('nota_', 'id_')], event.newValue)
        console.log(event.newData)
        return
    }
    salvarNotacao(event.newValue, event.newData.id, disciplina, trimestre)


}

async function salvarNotacao(notacao, estudante, disciplina, trimestre) {

    const { data, error } = await supabase
        .from('notacoes')
        .insert({ notacao: notacao, estudante: estudante, disciplina: disciplina, trimestre: trimestre, ano_letivo: anoAtual.value })
        .select()

    if (error) {
        alert('Ocorreu um erro ao salvar as notas. Experimento recarregar a página ' + error.message)
        return
    }


}
async function atualizarNotacao(id, notacao) {
    const { data, error } = await supabase
        .from('notacoes')
        .update({ notacao: notacao })
        .eq('id', id)

    if (error) {
        alert('Ocorreu um erro ao salvar as notas. Experimento recarregar a página ' + error.message)
        return
    }
}

async function carregarEstudantes() {
    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
        .from('estudantes_turmas')
        .select('users(id, nome, img)')
        .eq('idDaTurma', turma.value.idDaTurma)
        .order('nome', {
            foreignTable: 'users',
            ascending: true
        })

    if (error) {
        console.log('Ocorreu um erro ao carregar os estudantes: ' + error.message)
        store.dispatch('updateLoading', false)
        return
    }

    store.dispatch('updateLoading', false)
    estudantes.value = data
}
async function carregarDisciplinas() {
    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
        .from('aulas')
        .select('cursos(disciplinas(id, nome, area_conhecimento, id_area))')
        .eq('id', turma.value.idDaAula)
        .single()

    if (error) {
        store.dispatch('updateLoading', false)
        console.log('Ocorreu um erro ao carregar as disciplinas: ' + error.message)
        return
    }
    if (error) {
        console.log('Ocorreu um erro ao carregar as disciplinas: ' + error.message)
        store.dispatch('updateLoading', false)
        return
    }

    areaDoConhecimento.value = data.cursos.disciplinas.id_area
    disciplinaDoProfessor.value = data.cursos.disciplinas.id

    let { data: disciplinas, errorDisciplinas } = await supabase
        .from('disciplinas')
        .select("*")
        .eq('area_conhecimento', data.cursos.disciplinas.area_conhecimento)

    if (errorDisciplinas) {
        store.dispatch('updateLoading', false)
        console.log('Ocorreu um erro ao carregar as disciplinas: ' + errorDisciplinas.message)
        return
    }
    if (!disciplinas || disciplinas.length === 0) {
        console.log('Disciplinas não encontradas');
        store.dispatch('updateLoading', false)
        return;
    }

    disciplinasDaArea.value = disciplinas
    store.dispatch('updateLoading', false)


}
function mapearNotaParaCriterior(nota) {
    switch (nota) {
        case 1: return 'AB'
        case 2: return 'B'
        case 3: return 'AD'
        case 4: return 'AV'
    }
}
function getSeverityFromNota(nota) {
    switch (nota) {
        case 1: return "danger"
        case 2: return "warning"
        case 3: return "info"
        case 4: return "success"
        default: return "neutral"
    }
}
function extrairDisciplinaDeColuna(coluna) {
    let resultado = coluna.replaceAll('nota_', '')
    let length = resultado.length
    let disciplina = resultado.slice(0, length - 1)
    return disciplina

}
function extrairTrimestreDeColuna(coluna) {
    let resultado = coluna.replaceAll('nota_', '')
    let length = resultado.length
    let trimestre = resultado.slice(length - 1)
    return trimestre

}




</script>

<template>
    <div v-if="dadosCarregados" class="fadein animation-duration-500">
        <div>
            <DataTable :value="notas" tableStyle="min-width: 50rem" :scrollHeight="tableHeight" stripedRows scrollable
                resizableColumns columnResizeMode="fit" style="margin-top: 60px;" editMode="cell"
                @cell-edit-complete="onCellEditComplete" size="large" showGridlines>
                <template #header>
                    <div class="flex align-items-center justify-content-between">
                        <div style="text-align:left">
                            <MultiSelect v-model="trimestresSelecionados" :options="opcoesTrimestre" optionLabel="label"
                                placeholder="Selecione trimestres" class="w-full md:w-20rem mr-2 mb-1 md:mb-0"
                                display="chip" @change="carregarNotas()" />
                            <MultiSelect v-model="disciplinasSelecionadas" :options="disciplinasDaArea"
                                optionLabel="nome" placeholder="Selecione disciplinas" class="w-full md:w-20rem"
                                display="chip" @change="carregarNotas()" />
                        </div>
                        <div style="text-align:right" class="flex align-items-center gap-3">
                            <ParecerCriarParecerParaEstudantes v-if="pareceres.length == 0" :anoLetivo="anoAtual"
                                :turma="turma" :disciplinas="disciplinasDaArea" :estudantes="estudantes" />
                            <ParecerCopiarPareceres v-if="pareceres.length > 0" :pareceres="pareceres" />
                            <ParecerExcluirPareceres v-if="pareceres.length > 0"
                                :idPareceres="pareceres.map(parecer => parecer.id)" />

                        </div>
                    </div>
                </template>
                <Column field="nome" header="Estudante" frozen sortable class="w-10rem"
                    v-if="disciplinasSelecionadas.length > 0 && trimestresSelecionados.length > 0">
                    <template #body="slotProps">
                        <div v-tooltip.top="slotProps.data.nome"
                            class="estudante-column flex gap-2 align-items-center ">
                            <img :src="slotProps.data.img" :alt="slotProps.data.nome"
                                style="min-width:60px; min-height: 60px; max-width:60px; max-height: 60px; border-radius:50%; object-fit: cover;">
                            <p class="nome-estudante">{{ slotProps.data.nome }}</p>
                        </div>
                    </template>
                </Column>

                <Column v-for="col of colunasSelecionadas" :field="`nota_${col.id}`" :key="col.id" sortable
                    v-if="disciplinasSelecionadas.length > 0 && trimestresSelecionados.length > 0" class="w-5rem">
                    <template #header>
                        <div class="flex flex-column gap-1 align-items-center"
                            @contextmenu="onContextMenuClick($event, `nota_${col.id}`)">
                            <div>{{ col.disciplina.nome }}</div>
                            <div class="text-sm font-normal text-color-secondary">{{ col.trimestre.label }}</div>

                        </div>
                    </template>
                    <template #body="slotProps">
                        <Tag v-if="slotProps.data[`nota_${col.id}`] !== null && slotProps.data[`nota_${col.id}`] !== 0"
                            class="block text-center truncate cursor-pointer w-6rem"
                            :value="mapearNotaParaCriterior(slotProps.data[`nota_${col.id}`])"
                            :severity="getSeverityFromNota(slotProps.data[`nota_${col.id}`])" />
                        <div v-else
                            class="w-6rem border-1 border-200 cursor-pointer flex justify-content-center align-content-center"
                            style="height: 1.7rem; border-radius: 6px;">
                            <div class="pi pi-lock text-200 p-1"
                                v-if="extrairDisciplinaDeColuna(`nota_${col.id}`) != disciplinaDoProfessor"></div>
                        </div>
                    </template>
                    <template #editor="{ data, field }">
                        {{ console.log('Disciplina do campo ' + extrairDisciplinaDeColuna(field)) }}
                        {{ console.log(disciplinaDoProfessor) }}
                        <div v-if="extrairDisciplinaDeColuna(field) == disciplinaDoProfessor">


                            <Dropdown v-model="data[field]" :options="notacoesPadrao" optionLabel="nome"
                                optionValue="valor" placeholder="" class="w-6rem" />
                        </div>
                        <div v-else>
                            <div class="text-sm font-normal text-color-secondary">Você não pode editar uma disciplina
                                que
                                não é sua</div>

                        </div>
                    </template>
                </Column>
                <Column field="parecer" header="Parecer" style="max-width: 100px;"
                    v-if="disciplinasSelecionadas.length > 0 && trimestresSelecionados.length == 1">
                    <template #body="slotProps">
                        <div v-if="slotProps.data.parecer"
                            class="white-space-nowrap overflow-hidden text-overflow-ellipsis cursor-pointer texto-parecer "
                            @click="editarParecer(slotProps.data)" v-tooltip.top="slotProps.data.parecer">

                            <div class="">{{ slotProps.data.parecer }}</div>
                        </div>
                        <div v-else class="pi pi-file-edit text-lg text-color cursor-pointer"
                            @click="editarParecer(slotProps.data)">

                        </div>
                    </template>
                </Column>
                <Column field="parecer" header="Copiar Parecer"
                    v-if="disciplinasSelecionadas.length > 0 && trimestresSelecionados.length == 1">
                    <template #body="slotProps">
                        <CopiarParecerComponent :parecer="slotProps.data.parecer" />
                    </template>
                </Column>
            </DataTable>
            <ContextMenu ref="menu" :model="items" />
            <Dialog v-if="dadosEditarParecer" v-model:visible="visible" modal maximizable
                :header="dadosEditarParecer.nome" :style="{ width: '50rem' }"
                :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
                <Textarea v-model="parecer" autoResize rows="7" class="w-full mt-1" />
                <Button :loading="btnLoading" label="Salvar" @click="salvarParecer" class="mt-3 w-full" />
            </Dialog>
        </div>
    </div>
</template>


<style scoped>
.estudante-column {
    max-width: 180px;
}
.texto-parecer{
    max-width: 200px;
}
.nome-estudante {
    max-width: 180px;
    white-space: normal;
    /* Permite quebra de linha */
    display: -webkit-box;
    /* Define um contêiner flexível baseado em WebKit */
    -webkit-box-orient: vertical;
    /* Define a orientação das caixas como vertical */
    -webkit-line-clamp: 3;
    /* Limita a 3 linhas */
    overflow: hidden;
    /* Esconde o excesso de texto */
    text-overflow: ellipsis;
    /* Adiciona "..." ao final do texto cortado */
}
</style>